import PropTypes from 'prop-types';
import { useMemo } from 'react';
import createMemoizedContextProvider from './CreateMemoizedContextProvider';

const { useContext: useTestTypeObjectContext, Provider } = createMemoizedContextProvider('TestTypeContext');

export const TestTypeContextProvider = ({ children, testType }) => {
    const contextValue = useMemo(() => ({ testType }), [testType]);
    return <Provider value={contextValue}>{children}</Provider>;
};

TestTypeContextProvider.propTypes = {
    children: PropTypes.node,
    testType: PropTypes.object,
};

TestTypeContextProvider.defaultProps = {
    children: null,
    testType: {},
};

export default useTestTypeObjectContext;
